import { StatusAccessREquest } from "@/enum/status";

export const asKnownStatus = (
  value: string | null | undefined,
): StatusAccessREquest | null => {
  const known: boolean =
    !!value &&
    Object.values(StatusAccessREquest).includes(value as StatusAccessREquest);

  return known ? (value as StatusAccessREquest) : null;
};
